import FJActionConstant from "../../constant/FJActionConstant";
import FJViewConstant from "../../constant/FJViewConstant";

const initState = {
  showType: FJViewConstant.RESOURCES_MEDIA,
  lastType: FJViewConstant.RESOURCES_MEDIA,
  direction: 1,
  isResourceExpand: true,
};

export default function (state = initState, action) {
  switch (action.type) {
    case FJActionConstant.UPDATE_SHOW_TYPE:
      return {
        ...state,
        showType: action.showType,
        direction: action.direction,
      }
    case FJActionConstant.UPDATE_LAST_TYPE:
      return {
        ...state,
        lastType: action.lastType
      }
    case FJActionConstant.TOGGLE_RESOURCE_EXPAND:
      return {
        ...state,
        isResourceExpand: action.isResourceExpand
      }
    default:
      return state;
  }
}
